export function textToClipboard (text) {
  let dummy = document.createElement('textarea')
  document.body.appendChild(dummy)
  dummy.value = text
  dummy.select()
  document.execCommand('copy')
  document.body.removeChild(dummy)
}



// WEBPACK FOOTER //
// ./src/utils/clipboard.js